<template>
  <div class="scroll-message-row" v-show="showSelf">
    <div class="page-size-container content-box">
      <div class="scroll-icon-box">
        <i class="el-icon-bell"></i>
        <!--<img class="scroll-icon-message" :src="images.message"/>-->
      </div>
      <div class="scroll-target" v-if="showSelf" @click.stop="handlerParentClick">
        <vue-seamless-scroll :data="list" :class-option="classOption" class="top-message" ref="seamlessScroll">
          <div class="message-list">
            <div class="message-item" v-for="(item, index) in list" :key="index" :data-index="index">
              <img :src="images.iconNew" class="icon-img" v-if="[1,2].includes(item.type)">
<!--              <img :src="images.iconHasUpdate" class="icon-img" v-else-if="item.type === 3">-->
<!--              <i class="icon-tag" v-else-if="item.type === 3">有更新</i>-->
              <img :src="images.iconHasUpdate" alt="" v-else-if="item.type === 3" style="height: 24px;">
              <div class="message-content" v-html="item.label"></div>
            </div>
          </div>
        </vue-seamless-scroll>
      </div>
    </div>
    <div class="close" @click="close">
      <span class="icon el-icon-close"></span>
    </div>
  </div>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
import {isArray} from "my-tools-kit";
export default {
  name: "scrollMessageRow",
  components: {
    vueSeamlessScroll
  },
  props:{
    // 列表数据 Array<{label:"",type:1,key...}>
    list:{
      type:Array,
      default:()=>[],
    },
    // 数值越大速度滚动越快。
    step:{
      type:Number,
      default:1,
    },
    // 开启无缝滚动的数据量。
    limitMoveNum:{
      type:Number,
      default:3,
    },
  },
  data(){
    const ossPath = this.ossPath;
    return {
      images:{
        message: ossPath + "/pages/home/icon_notice_white.png",
        iconHasUpdate: ossPath + "/pages/home/icon_has_new.png",
        iconNew: ossPath + "/pages/home/icon_message_new.png",
      },
      showSelf:true,
    }
  },
  computed:{
    classOption(){
      return {
        // 方向: 0 往下 1 往上 2 向左 3 向右。
        direction:2,
        step:this.step,
        limitMoveNum:this.limitMoveNum,
        // autoPlay:false,
      }
    }
  },
  watch:{
    list:{
      immediate:true,
      handler(newVal){
        console.log("%c watch list","color:red;")
        this.$nextTick(()=>{
          this.$refs.seamlessScroll.reset();
        })
      },
    }
  },
  methods:{
    close(){
      this.showSelf = false;
    },
    /**
     * 滚动元素的父级挂载click事件代理
     */
    handlerParentClick(e){
      let $target = e.target;
      let result = this.eachFindItem($target);
      if(result){
        let index = result.getAttribute("data-index");
        if(typeof index === "string") index = parseInt(index);
        if(index >= 0){
          let item = this.list[index];
          if(item) this.clickItem(item,index);
        }
      }
    },
    /**
     * 查找触发点击代理的元素是否符合目标
     * @param $target
     * @return {boolean|*}
     */
    eachFindItem($target){
      if($target.className.match("scroll-target")) return false;
      if($target.className.match("top-message")) return false;
      if($target.className.match("message-list")) return false;
      if($target.className.match("message-item")) return $target;
      if($target.parentNode) return this.eachFindItem($target.parentNode);
      return false;
    },
    /**
     * 点击item
     * @param item
     * @param index
     */
    clickItem(item,index){
      console.log("点击新消息",item,index)
      // 通知类型：1、新上国家 2、新上专线报价 3、更新价格
      let type = item.type;
      if(type === 1){
        let params = {
          // 目的国
          toCountryid:item.countryId,
          toCountryCode:item.countryCode,
          toCountryName:item.countryName,
          // 起运地
          fromCityid:item.polId,
          fromCityCode:item.polCode,
          fromCityName:item.polName,
        };
        this.toPrivateLineHall(params);
      }else if([2,3].includes(type)){
        let params = {
          transportCodes:item.transportType,
          // 目的国
          toCountryid:item.countryId,
          toCountryCode:item.countryCode,
          toCountryName:item.countryName,
          // 起运地
          fromCityid:item.polId,
          fromCityCode:item.polCode,
          fromCityName:item.polName,
          // 运输方案id
          transportSchemeId: item.transportSchemeId,
        };
        this.toPrivateLineHall(params);
      }
    },
    /**/
    toPrivateLineHall(options){
      let itemData = {
        // 运输方式code  HY-海运 KY-空运 LY-陆运
        transportCodes: options.transportCodes,
        // 转运类型 1-直拼 2-转运
        transferType:"",
        // 目的国id
        toCountryid: options.toCountryid,
        countryId: options.toCountryid,
        // 目的国家代码
        toCountryCode: options.toCountryCode,
        countryCode: options.toCountryCode,
        // 目的国名称
        toCountryName: options.toCountryName,
        tocountryName: options.toCountryName,
        countryName: options.toCountryName,
        countryNamec: options.toCountryName,
        // 起运城市id
        fromCityid: options.fromCityid,
        // 起运城市代码
        fromCityCode: options.fromCityCode,
        // 起运城市名称
        fromCityName: options.fromCityName,
        // 目的地类型  0全部，1fba, 2私人地址
        podlandType: "",
        // 私人地址派送类型
        privateAddressType: options.privateAddressType,
        // 是否私人地址
        isPrivateAddress:"",
        // 目的仓库id
        // toStoreid: options.privateAddressType === 3 ? (isArray(options.toStoreid) ? options.toStoreid :[options.toStoreid] ) : options.toStoreid,
        // 目的仓库id 默认展示全部
        toStoreid: options.privateAddressType === 3 ? [] : "",
        // 目的仓库名称
        tostoreName:"",
        // 目的仓库信息
        toWarehouseInfo:{
          // 仓库地址
          address:"",
          // 仓库所属城市名称
          city:"",
          // 仓库所属城市id
          cityId:"",
          // 仓库所属国家名称
          country:"",
          // 仓库所属国家代码
          countryCode:"",
          // 仓库所属国家id
          countryId:"",
          // 仓库类型 0：非FBA仓库(亦邦、FBN) 1：FBA仓库
          privateAddressType: options.privateAddressType,
          // 仓库id
          id:"",
          // 仓库名称
          namec:"",
        },
        // 商品类型
        goodsType:"",
        // 商品名称
        goodsName:"",
        goodNameInfo:"",
        // 关键词
        keyword:"",
        // 运输方案id
        transportSchemeId: options.transportSchemeId,
        opening:true,
        // 目的地相关id数组：0-目的国家id ,1-目的仓库id
        toSelectId:[options.toCountryid,""],
        // 起运地相关id数组：0-起运(国家/省份/)id ,1-起运城市id
        fromSelectId:[null,options.fromCityid],
        // 起运城市信息
        fromCityInfo:{
          // 城市代码
          code: options.fromCityCode,
          // id
          id: options.fromCityid,
          // 中文名
          namec: options.fromCityName,
          // 英文名
          namee:"",
          // 省名称
          provinceName:"",
          // id
          value: options.fromCityid,
        },
      };
      this.$router.push({
        name: "queryPrice",
        query: {
          name:"首页滚动消息",
          type:false,
          itemData:JSON.stringify(itemData),
        },
      })
    },
  },
}
</script>

<style lang="less" scoped>
@itemHeight:40px;
.scroll-message-row{
  position: relative;
  z-index: 1;
  font-size: 14px;
  color: white;
  box-sizing: border-box;
  /deep/ .markup-text{
    color: #FCD124;
    //color: #ff0000;
    font-weight: bold;
    font-size: 16px;
  }
  height: @itemHeight;
  .content-box{
    display: flex;
    align-items: center;
    height: 100%;
    overflow: hidden;
    .scroll-icon-box{
      width: (@itemHeight - 10px);
      height: 100%;
      display: flex;
      align-items: center;
      i{
        font-size: 20px;
        color: #FF9E70;
        line-height: 1.2;
      }
      .scroll-icon-message{
        display: block;
        width: auto;
        height: 21px;
      }
    }
    .scroll-target{
      flex: 1;
      height: 100%;
      overflow: hidden;
    }
  }
  .close{
    position: absolute;
    z-index: 2;
    width: 25px + 6px * 2;
    height: 100%;
    top: 0;
    right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    //color: #999999;

    &:hover{
      color: #999;
    }
    .icon{
      font-size: 18px;
      font-weight: bold;
      line-height: 1;
    }
    @media screen and (max-width: 1260px){
      right:0;
    }
  }
}
.top-message {
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  .message-list{
    display: flex;
  }
  .message-item{
    display: flex;
    align-items: center;
    width: auto;
    line-height: @itemHeight;
    margin-right: 24px;
    white-space: nowrap;
    cursor: pointer;
    .icon-img{
      display: block;
      border: none;
      width: auto;
      height: 28px;
      min-width: 34px;
      margin-right: 6px;
    }
    .icon-tag{
      display: block;
      height: 24px;
      line-height: 24px;
      border-radius: 2px 8px 2px 8px;
      width: auto;
      padding: 0 6px;
      background-color: #f24957;
      color: white;
      font-size: 14px;
      margin-right: 6px;
    }
    &:hover{
      text-decoration: underline;
    }
  }
}
.page-size-container {
  width: calc(100% - 70px);
  margin-left: 20px;
  margin-right: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/placeOrder/components/scrollMessageRow/index.vue